import React, {useState, useEffect, useRef} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import {Timeline} from 'primereact/timeline';
import {Tooltip} from "primereact/tooltip";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import _FM_ReservationFolioListComponent from "../../components/_FM_folio/_FM_FolioListComponent";

const _FM_ReservationgroupShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [formData, setFormData] = useState({});
  const [attachData, setAttachData] = useState({});
  const [statuses, setStatuses] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [unit, setUnit] = useState([]);
  const [berth, setBerth] = useState([]);
  const [email, setEmail] = useState({
    language: Cookies.get("language").toUpperCase(),
    client_domain: process.env.REACT_APP_APP_PROTOCOL + window.location.hostname.split('.')[0]
      + "." + process.env.REACT_APP_APP_HOST.replace('/#/', '/#')
  });
  const [loading, setLoading] = useState(false);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  useEffect(() => {
    if (attachData.residential_unit) {
      apiCall('get', 'berth' + '?search[residential_unit][operator]=%3D&search[residential_unit][value]=' + attachData.residential_unit)
        .then(response => {
          setLoading(false)
          setBerth(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }

  }, [attachData.residential_unit])

  useEffect(() => {
    setLoading(true)
    if (props.reservationGroupId || id) {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation-group/" + (props.reservationGroupId ?? id),
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setReservations(response.data.data.reservations);
          setFormData(response.data.data);
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
    apiCall('get', 'residential-unit')
      .then(response => {
        setLoading(false)
        setUnit(response.data.data.items);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
            {t('reservation_group')}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          {!window.location.href.includes('#/reservation') &&
            <Button type="button"
                    icon={"pi pi-times"}
                    onClick={() => {
                      navigate(-1)
                    }}
                    className="p-button-secondary close p-ml-2">
            </Button>
          }
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('reservation_number')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {formData?.public_id?.toUpperCase()}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('group')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {formData?.group?.name || t('no_group_found')}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        <div className={"p-grid"}>
          <div className={"p-col p-col-align-center"}>
            <h2 className={"p-m-0"}>{t('reservation_group_reservations')}</h2>
          </div>
        </div>
        {formData.id && reservations && reservations[0] ? (
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-12"}>
              <div className="p-field p-fluid" style={{position: 'relative', paddingLeft: '20px'}}>
                        <span style={{
                          position: 'absolute',
                          left: '0',
                          top: '0',
                          height: '100%',
                          borderLeft: '10px solid #' + window.App.generateHexFromNumber(formData.id),
                        }}></span>
                <span className="p-d-block p-text-bold">
                            <div className={"reservations"}>
                              <Timeline value={reservations} align={"left"}
                                        marker={() => {
                                          return (
                                            <>
                                              <i className={"pi pi-home p-mt-1"}
                                                 style={{color: "#" + window.App.generateHexFromNumber(formData?.id)}}></i>
                                            </>
                                          )
                                        }}
                                        content={(item) => {
                                          return (
                                            <div className={"p-grid"}>
                                              <div className={"p-col-12 p-lg-5 p-col-align-center"}>
                                                <div className={"p-grid"}>
                                                  <div className={"p-col-12 p-lg-6"}>
                                                    {item.residential_unit &&
                                                      <>
                                                        {item.residential_unit.name}
                                                      </>
                                                    }
                                                    {item.berth?.residential_unit &&
                                                      <>
                                                        {item.berth.residential_unit.name}
                                                      </>
                                                    }
                                                  </div>
                                                  <div className={"p-col-12 p-lg-6 p-pl-0"}>
                                                    {item.berth &&
                                                      <>
                                                        <i className={"pi pi-inbox p-ml-0 p-mr-3"}
                                                           style={{color: "#" + window.App.generateHexFromNumber(formData?.reservation_group?.id)}}></i>
                                                        {item.berth.name}
                                                      </>
                                                    }
                                                  </div>
                                                </div>
                                                <div className={"p-grid"}>
                                                  <div className={"p-col-12 p-lg-6 p-p-0"}>
                                                    <small className={"p-pl-2"}>
                                                      {moment.utc(item.reserved_from).local().format(t('YYYY-MM-DD HH:mm'))}
                                                    </small>
                                                  </div>
                                                  <div className={"p-col-12 p-lg-6 p-p-0"}>
                                                    <small>
                                                      {moment.utc(item.reserved_to).local().format(t('YYYY-MM-DD HH:mm'))}
                                                    </small>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className={"p-col-12 p-lg-5 p-col-align-center"}>
                                                {item.public_id !== formData.public_id &&
                                                  <>
                                                    <span
                                                      className={"tt-association-code-rg-info-" + item.id + " p-mr-2"}
                                                      data-pr-tooltip={item.association_code}>
                                                      <i className={"pi pi-info-circle"} style={{
                                                        fontSize: '0.85rem',
                                                        color: '#6c757d',
                                                        cursor: 'pointer'
                                                      }}></i>
                                                    </span>
                                                    <Tooltip target={".tt-association-code-rg-info-" + item.id}/>
                                                    <span className={"p-badge p-text-nowrap"}
                                                          style={{
                                                            fontSize: '1rem',
                                                            backgroundColor: item?.status
                                                              ? item?.status?.toLowerCase() === 'pending'
                                                                ? '#dddddd'
                                                                : item?.status?.toLowerCase() === 'confirmed'
                                                                  ? '#f1eea5'
                                                                  : item?.status?.toLowerCase() === 'cancelled'
                                                                    ? '#f7a2a2'
                                                                    : item?.status?.toLowerCase() === 'checked_in'
                                                                      ? '#3ec0e9'
                                                                      : item?.status?.toLowerCase() === 'checked_out'
                                                                        ? '#0abb87'
                                                                        : item?.status?.toLowerCase() === 'no_show'
                                                                          ? '#8a2be2'
                                                                          : '#ccc'
                                                              : undefined,
                                                            color: item?.status
                                                              ? item?.status?.toLowerCase() === 'pending' || item?.status?.toLowerCase() === 'confirmed'
                                                                ? '#5f656b'
                                                                : item?.status?.toLowerCase() === 'no_show'
                                                                  ? '#fff'
                                                                  : undefined
                                                              : undefined
                                                          }}>
                                                      {item?.association_code?.split(' | ').pop()?.trim()}
                                                    </span>
                                                  </>
                                                }
                                              </div>
                                              <div className={"p-col-12 p-lg-2 p-col-align-center"}>
                                                {!window.location.href.includes('#/reservation') &&
                                                  <Button
                                                    type="button"
                                                    label={t('show')}
                                                    icon={'pi pi-window-maximize'}
                                                    className="p-button p-button-info p-d-block w-100"
                                                    onClick={() => {
                                                      window.open('/#/reservation/read/' + item.id, '_blank', 'noopener,noreferrer');
                                                    }}                                                />
                                                }
                                              </div>
                                            </div>
                                          )
                                        }}/>
                            </div>
                          </span>
              </div>
            </div>
          </div>
        ) : (
          <p>
            {t('attach_reservation_on_edit_reservation')}
          </p>
        )}
      </Panel>
      {formData.id && window.location.href.includes('#/reservation-group') &&
        <Panel className={"p-mt-3"}>
          <_FM_ReservationFolioListComponent reservationGroupId={formData.id}/>
        </Panel>
      }
      {formData.resnweb_room_reference_id &&
        <Panel className={"p-mt-3"}>
          <h2 className={"p-mt-0"}>
            RESnWEB
          </h2>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="captured_at">RESnWEB reference ID</label>
                <span className="p-d-block p-text-bold">
             {formData?.resnweb_reference_id}
            </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="captured_at">RESnWEB room reference ID</label>
                <span className="p-d-block p-text-bold">
             {formData?.resnweb_room_reference_id}
            </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="captured_at">RESnWEB guest reference ID</label>
                <span className="p-d-block p-text-bold">
             {formData?.resnweb_guest_reference_id}
            </span>
              </div>
            </div>
          </div>
        </Panel>
      }
    </>
  )
}
export default withTranslation('common')(_FM_ReservationgroupShowComponent);
